import { Config, Connect } from '@vkontakte/superappkit';
import { UpdateType } from '../../utils/const';

export class VKConnect {
  constructor(options, vkAuthModel) {
    this._appId = options.appId;
    this._appSettings = options.appSettings;
    this._superAppToken = options.superAppToken || '';
    this._authAction = options.authAction;
    this._isLogEnable = options.debug;

    this._model = vkAuthModel;

    this._handleModelEvent = this._handleModelEvent.bind(this);
  }

  init() {
    this._model.addObserver(this._handleModelEvent);
    this._initApp();
  }

  _handleModelEvent(updateType) {
    switch (updateType) {
      case UpdateType.AUTH:
        this._userVisibleAuth();
        break;
      case UpdateType.CLICK:
        this._model.isAuth ? this._authUser() : this._userVisibleAuth();
        break;
    }
  }

  async _initApp() {
    Config.init({
      appId: this._appId,
      appSettings: this._appSettings,
      superAppToken: this._superAppToken,
      _debug: this._isLogEnable
    });

    Config.onRequestSuperAppToken(() => {
      Config.setSuperAppToken(this._superAppToken);
    });

    Config.onAuth(() => {
      this._userVisibleAuth();
    });

    await this._silentAuth()
  }

  async _silentAuth() {
    await Connect.silentAuth().then((data) => {
      const isSilentAuthSuccess = data?.payload?.auth;

      this._log('SilentAuth success: ', data);
      this._model.data = data;
      this._model.updateIsAuth(UpdateType.INIT, isSilentAuthSuccess);

      window.$analytics?.push('vk-connect-authorization', {isAuth: this._model.isAuth});
    }).catch((err) => {
      // TODO непонятно надо ли логать т.к. при cors постоянно валится, но err отсутствует, других причин не увидел
      if (err) {
        this._sendErrorMessage('Не удалось выполнить Silent Auth', err);
      }

      window.$analytics?.push('vk-connect-authorization', {isAuth: false});
    });
  }

  _userVisibleAuth() {
    Connect.userVisibleAuth().then((data) => {
      this._log('VisibleAuth success: ', data);

      if (this._model.isAuth) {
        this._authUser();
        return;
      }

      this._model.data = data;
      this._model.updateIsAuth(UpdateType.AUTH, data.payload && data.payload.auth);
    }).catch((err) => {
      // закрытие окна с авторизацией
      const isCloseWindow = err && err.code === 7

      if (!isCloseWindow) {
        this._sendErrorMessage('Не удалось авторизоваться через попап', err);
      }
    });
  }

  _getFillDataTypeByString(data) {
    const dataFilled = Object.entries(data).filter((item) => !!item[1]);
    const dataTypeFilled = dataFilled.map((item) => item[0]);

    return dataTypeFilled.join(', ');
  }

  _authUser() {
    const { token, uuid, user } = this._model.data.payload;

    return fetch(this._authAction, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({
        token,
        uuid,
      }),
    })
      .then((response) => {
        if (response.status < 200 || response.status > 299) {
          this._sendErrorMessage('Ошибка получения данных пользователя', response)
        }

        return response.json()
      })
      .then(({ response }) => {
        const userData = {
          name: user.first_name,
          phone: response.phone,
          email: response.email,
        };
        const filteredData = Object.fromEntries(Object.entries(userData).filter(([, value]) => value !== null))

        this._model.updateUserData(UpdateType.CONNECT, filteredData);

        window.$analytics?.push('vk-connect-form-complete', {
          completeData: this._getFillDataTypeByString(userData)
        });
        window.$analytics?.push('vk-auth', {
          userId: uuid
        });
      }).catch((err) => {
        this._sendErrorMessage('Ошибка авторизации на сервере', err);
      });
  }

  _sendErrorMessage(event, data) {
    event = `[Vk-Connect]: ${event}`;

    this._log(event, data);

    window.Sentry.captureException(`${event} ${data ? JSON.stringify(data) : ''}`);
  }

  _log(event, data) {
    if (this._isLogEnable) {
      console.log(event, data); // eslint-disable-line no-console
    }
  }
}
